<div class="row">
    <div class="col-lg-12 pt-2">
        <div class="form-group row">
            <div class="col-12 col-sm-12 col-md-12 col-lg-12 col-xl-12">
                <dhs-form [config]="configForm" [fieldGroup]="fields" (saveFinished)="saveFinished($event)"
                 [action]="'ADD'" [formtype]="'popup'" [data]="objData"></dhs-form>
                <div class="col-md-3 col-lg-3 col-xl-3"></div>
            </div>
        </div>
    </div>
</div>
